import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * cn — combine class names, with Tailwind conflict resolution.
 * Lets us write `cn('px-4 py-2', condition && 'bg-primary', overrideClass)`
 * and have later classes correctly override earlier ones (e.g. px-4 vs px-6).
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
